module.exports = __webpack_public_path__ + "static/media/20210409_212328_333_IMG_0215.db63fc76.jpg";